// cursor.js - handles custom cursor interactions
export function initCursor() {
    const cursor = document.querySelector('.cursor');
    const cursorinner = document.querySelector('.cursor-inner');
    const anchors = document.querySelectorAll('a');
    if (!cursor || !cursorinner) return;

    document.addEventListener('mousemove', function(e){
        cursor.style.transform = `translate3d(calc(${e.clientX}px - 50%), calc(${e.clientY}px - 50%), 0)`;
        cursorinner.style.left = e.clientX + 'px';
        cursorinner.style.top = e.clientY + 'px';
    });
    document.addEventListener('mousedown', function(){ cursor.classList.add('click'); cursorinner.classList.add('cursorinnerhover'); });
    document.addEventListener('mouseup', function(){ cursor.classList.remove('click'); cursorinner.classList.remove('cursorinnerhover'); });
    anchors.forEach(item => { item.addEventListener('mouseover', () => { cursor.classList.add('hover'); }); item.addEventListener('mouseleave', () => { cursor.classList.remove('hover'); }); });
}
